import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { AuthService } from './auth/auth.service'

/**
 * @Injectable({ providedIn: 'root' })
 * @export class SuperAdminGuard
 *
 * Sibling of {@link AuthGuard}, same shape: guards access to the "Configurazione Attributi"
 * area (and any future SuperAdmin-only route) by checking the `superAmministratore` flag on the
 * locally-stored logged user. `AuthGuard` already ran first (this guard's routes are nested under
 * it), so a missing/invalid user here still falls back to `/login`, mirroring `AuthGuard`'s own
 * failure behaviour exactly.
 */
@Injectable({
    providedIn: 'root',
})
export class SuperAdminGuard implements CanActivate {
    private auth = inject(AuthService)
    private router = inject(Router)

    /**
     * Checks if the logged user is a SuperAdmin and redirects to the login page if not.
     *
     * @returns {boolean} `true` if the user is a SuperAdmin, `false` otherwise.
     */
    canActivate(): boolean {
        if (this.auth.getUserResult()?.superAmministratore === true) {
            return true
        } else {
            this.router.navigate(['/login'])
            return false
        }
    }
}
